module.exports = __webpack_public_path__ + "i18n/it.96c5e510f18dbd9b39dfe9facbac736e.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/it.json
// module id = 1309
// module chunks = 59